<template>
  <tr class="table-centralized">
    <td>{{ reenrollmentContract.id }}</td>
    <td>{{ reenrollmentContract.period }}</td>
    <td>{{ translateEnabled(reenrollmentContract.enabled) }}</td>
    <td>{{ reenrollmentContract.created_at | formatDate }}</td>
    <td>{{ reenrollmentContract.enabled_until | formatDate }}</td>
    <td>
      <div v-if="reenrollmentContract.enabled" class="dropdown">
        <button
          class="btn btn-primary dropdown-toggle"
          :id="`dropdown-reenrollment-options-${reenrollmentContract.id}`"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          Ações
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu" :aria-labelledby="`dropdown-reenrollment-options-${reenrollmentContract.id}`">
          <li>
            <a @click="exportStudentsReenrollment">
              Exportar planilha de alunos
            </a>
          </li>
          <li>
            <a @click="emitReenrollmentContract('import')">
              Importar planilha de alunos
            </a>
          </li>
          <li>
            <a @click="emitReenrollmentContract('disable')">
              Finalizar período de rematrícula
            </a>
          </li>
        </ul>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState([
      'institution',
    ]),
  },
  props: {
    reenrollmentContract: {
      type: Object,
      required: true,
    },
  },
  methods: {
    exportStudentsReenrollment() {
      const url = `${this.$serverHost}/admin/rematricula/export.xlsx?institution_id=${this.institution.id}
        &reenrollment_contract_id=${this.reenrollmentContract.id}`;
      window.open(url);
    },
    translateEnabled(enabled) {
      return enabled ? 'Em andamento' : 'Finalizado';
    },
    emitReenrollmentContract(emitEvent) {
      this.$emit(emitEvent, this.reenrollmentContract.id);
    },
  },
};
</script>
